import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import VueI18n from 'vue-i18n';
import { pl } from '@/translations/pl';
import { en } from '@/translations/en';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import { localeService } from './services/LocaleService';

Vue.config.productionTip = false;

(window as any).Vue = Vue;

const i18n = new VueI18n({
  locale: localeService.getLocale(),
  fallbackLocale: 'pl',
  messages: { pl, en },
});

(window as any).VueGlobal = new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');

if (process.env.VUE_APP_DSN_URL) {
  Sentry.init({
    dsn: process.env.VUE_APP_DSN_URL,
    integrations: [new Integrations.BrowserTracing()],
  });
}
